import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "../../../../../../../../types"
import { useApi } from "../../../../../../../../utils"

export function useUniversity() {
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(false)

  const refetch = () => {
    setLoading(true)

    api.get("/university/")
    .then((res: SuccessFetch<{
      payload: {
        university_id: number
        university_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.university_name, value: item.university_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  }

  useEffect(() => {
    setLoading(true)

    api.get("/university/").then((res: SuccessFetch<{
      payload: {
        university_id: number
        university_name: string
      }[]
    }>) => {
      setData(res.data.payload.map(item => {
        return {
          label: item.university_name,
          value: item.university_id?.toString()
        }
      }))
    }).catch(() => {
      setData([])
    }).finally(() => {
      setLoading(false)
    })
    // eslint-disable-next-line
  }, [])

  return { data, isLoading, refetch }
}